import React from 'react';
import { Form, Radio } from 'antd';
import './CustomerRadioInput.scss';

function CustomerRadioInput({
  name, className, errorMessage, options, groupClassName = '', label, rules = [],
}) {
  return (
    <Form.Item
      className={`customer-radio-input ${className}`}
      name={name}
      validateStatus={errorMessage && 'error'}
      help={errorMessage}
      label={label}
      rules={rules}
    >
      <Radio.Group className={groupClassName}>
        {options.filter((option) => option.visible).map(
          (option) => (
            <Radio
              key={option.value}
              disabled={option.disabled}
              value={option.value}
              className={`${option?.className || ''}`}
            >
              {option.label}
            </Radio>
          ),
        )}
      </Radio.Group>
    </Form.Item>
  );
}

export default CustomerRadioInput;
